import axios from 'axios';

const apiBaseUrl = window.clipship_config.ApiBaseUrl;

// Create an Axios instance
const httpClient = axios.create({
  baseURL: `${apiBaseUrl}`,
  timeout: 120000, // Set a timeout (optional)
});


httpClient.interceptors.request.use(function (response) {
    response.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
    return response;
  }, function (error) {
    return Promise.reject(error);
  });


httpClient.interceptors.response.use(function (response) {
     return response;
  }, function (error) {
     return new Promise(function(resolve,reject)
      {
        if (error.response && error.response && error.response.status !== 400/*&& error.response.status === 403 && !error.config.__isRetry*/)
        {
          window.dispatchEvent(new CustomEvent("unauthorized",{
            'detail': {
              'failedRequestInfo': { 
                'request': error.config,
                'resolve': resolve,
                'reject': reject
              }
            }
          }));
        }
        else {
          throw error;
        }
    });
  });

export default httpClient;
